import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import { isPropsEqual } from '@/shared/utils/props-comparison';

import NutritionalItem from './NutritionalItem';
import { AmountCaloriesComponent, AmountPerServing, NutritionCard } from './parts';
import type { NutritionalTree } from './types';

interface IProps {
  calories: NutritionalTree;
}

const AmountCalories: React.FC<IProps> = ({ calories }) => {
  const { formatMessage } = useIntl();
  const amountCaloriesTitle = formatMessage({
    id: 'Menus.Filters.MealCalculator.Labels.AmountCalories',
  });
  const list = calories.map((item) => (
    <React.Fragment key={item.Name}>
      <NutritionalItem item={item} />
    </React.Fragment>
  ));

  return (
    <AmountCaloriesComponent>
      <AmountPerServing className="AmountPerServing">
        {amountCaloriesTitle.toUpperCase()}
      </AmountPerServing>
      <NutritionCard className="NutritionCard">{list}</NutritionCard>
    </AmountCaloriesComponent>
  );
};

export default memo(AmountCalories, isPropsEqual);
